import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ecdb5060")

_pushScopeId("data-v-ecdb5060")
const _hoisted_1 = { class: "invoice" }
const _hoisted_2 = {
  key: 1,
  class: "invoice__loading"
}
const _hoisted_3 = { class: "invoice__body" }
const _hoisted_4 = { class: "body__side body__left" }
const _hoisted_5 = { class: "body__row" }
const _hoisted_6 = { class: "body__side body__right" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_send_to_email_modal = _resolveComponent("send-to-email-modal")!
  const _component_s_loader = _resolveComponent("s-loader")!
  const _component_invoice_header = _resolveComponent("invoice-header")!
  const _component_invoice_basic = _resolveComponent("invoice-basic")!
  const _component_invoice_additional = _resolveComponent("invoice-additional")!
  const _component_invoice_insurance = _resolveComponent("invoice-insurance")!
  const _component_invoice_destinations = _resolveComponent("invoice-destinations")!
  const _component_invoice_document = _resolveComponent("invoice-document")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isSendToEmail && _ctx.invoiceState.data)
      ? (_openBlock(), _createBlock(_component_send_to_email_modal, {
          key: 0,
          "invoice-number": _ctx.invoiceState.data.invoice_number,
          onClose: _ctx.cancelSendToEmail
        }, null, 8, ["invoice-number", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.invoiceState.state.is_loading)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_s_loader)
        ]))
      : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
          _createVNode(_component_invoice_header),
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              (_ctx.invoiceState.data)
                ? (_openBlock(), _createBlock(_component_invoice_basic, { key: 0 }))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_5, [
                (_ctx.invoiceState.data)
                  ? (_openBlock(), _createBlock(_component_invoice_additional, { key: 0 }))
                  : _createCommentVNode("", true),
                (_ctx.invoiceState.data)
                  ? (_openBlock(), _createBlock(_component_invoice_insurance, { key: 1 }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_6, [
              (_ctx.invoiceState.data)
                ? (_openBlock(), _createBlock(_component_invoice_destinations, { key: 0 }))
                : _createCommentVNode("", true)
            ])
          ])
        ], 64)),
    (Boolean(_ctx.invoiceState.data_print))
      ? (_openBlock(), _createBlock(_component_invoice_document, {
          key: 3,
          invoice: _ctx.invoiceState.data_print,
          class: "InvoiceDocument--dotted",
          style: {"padding-bottom":"10px"}
        }, null, 8, ["invoice"]))
      : _createCommentVNode("", true),
    (Boolean(_ctx.invoiceState.data_print))
      ? (_openBlock(), _createBlock(_component_invoice_document, {
          key: 4,
          invoice: _ctx.invoiceState.data_print,
          style: {"padding-top":"6px"}
        }, null, 8, ["invoice"]))
      : _createCommentVNode("", true)
  ]))
})